import React from "react";
import {
  useDeleteMany,
  useListContext,
  useRefresh,
  useNotify,
  useUnselectAll,
  Button,
} from "react-admin";
import DeleteIcon from "@material-ui/icons/Delete";

const BulkDeleteButton = ({ resource }) => {
  const { selectedIds } = useListContext();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll(resource);
  const [deleteMany, { isLoading }] = useDeleteMany();

  const handleDelete = () => {
    deleteMany(
      resource,
      { ids: selectedIds },
      {
        mutationMode: "pessimistic",
        onSuccess: () => {
          notify("Items deleted");
          unselectAll();
          refresh();
        },
        onError: () => {
          notify("Error deleting items", { type: "error" });
        },
      },
    );
  };

  return (
    <Button label="Delete" onClick={handleDelete} disabled={isLoading}>
      <DeleteIcon />
    </Button>
  );
};

export default BulkDeleteButton;
